<template>
    <q-card flat>
        <q-card-section>
            <div class="text-h5 text-bold text-uppercase">People</div>
        </q-card-section>
        <q-card-section class="q-pt-none q-pl-sm" v-if="processedData[version] && processedData[version]['coastalOffshore']">
            <q-list bordered class="rounded-borders bottom-border" role="list">
                <q-expansion-item v-model="summary" group="people" header-class="bg-grey-5"  expand-separator dense @click="goTo('summary', 'PEOPLE_SUMMARY')" class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                            Summary
                        </q-item-section>
                        <q-item-section v-if="summary">
                            <div class="row justify-end">
                                <div class="q-mt-xs q-mb-xs q-pl-sm q-pr-sm shadow-1 rounded"  @click.stop="print('peopleSummaryPane', version, 'People: Summary')" v-if="!printing" aria-label="Print summary"><q-icon name="print" size="xs"></q-icon></div>
                                <q-spinner v-else />
                            </div>
                        </q-item-section>
                    </template>
                    <router-view v-if="summary" :data="rawData" :version="version"></router-view>
                </q-expansion-item>

                <q-expansion-item v-model="cas" group="people"  expand-separator dense @click="goTo('cas', 'CAS_2016_2020')" class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                            Communities at Sea
                        </q-item-section>
                        <!-- <q-item-section v-if="cas">
                            <div class="row justify-end">
                                <q-btn class="q-mt-xs" icon="print"size="sm" @click.stop="print('casPane', version, 'Communities at Sea')" v-if="!printing"/>
                                <q-spinner v-else />
                            </div>
                        </q-item-section> -->
                    </template>
                    <router-view v-if="cas" :rawData="rawData" :version="version"></router-view>
                </q-expansion-item>
                <q-expansion-item v-model="otherAct" group="people"  expand-separator dense @click="goTo('other', 'PEOPLE_OTHER')" class="exp-panel" role="listitem">
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                            Other Activity & Human Use 
                        </q-item-section>
                        <!-- <q-item-section v-if="otherAct">
                            <div class="row justify-end">
                                <q-btn class="q-mt-xs" icon="print"size="sm" @click.stop="print('otherActivityPane', version, 'OtherActivity')" v-if="!printing"/>
                                <q-spinner v-else />
                            </div>
                        </q-item-section> -->
                    </template>
                    <router-view v-if="otherAct" :rawData="rawData" :version="version"></router-view>
                </q-expansion-item>
                <q-expansion-item
                    group="people"
                    dense
                    class="exp-panel"
                    expand-separator
                    label="Data Considerations"
                    @click="goTo('data', 'GRID')" 
                    v-model="dataqual"
                    header-class="bg-grey-5" 
                    role="listitem"
                >
                    <template v-slot:header>
                        <q-item-section class="text-uppercase text-bold">
                                Data Considerations
                        </q-item-section>
                        <!-- <q-item-section v-if="dataqual">
                            <div class="row justify-end">
                                <q-btn class="q-mt-xs" icon="print"size="sm" @click.stop="print('peopleDataConsiderationsPane', version, 'Data Considerations')" v-if="!printing"/>
                                <q-spinner v-else />
                            </div>
                        </q-item-section> -->
                    </template>
                    <router-view v-if="dataqual" :data="rawData" :version="version"></router-view>
                </q-expansion-item>
            </q-list>
        </q-card-section>
    </q-card>
    <div v-for="(infoObj, name) in infoDialogs" :key="name" >
        <q-dialog v-model="infoObj.model">
            <InfoDialog  :html="infoObj.text" :name="infoObj.pName"/>
        </q-dialog>
    </div>
</template>
<script setup lang="ts">
import { toRefs, onMounted, onUnmounted, ref, watch } from "vue";
import { useHelpers } from "../composables/useHelpers"
import { useMapItems } from "../composables/useMapItems"
import { useRouter, useRoute } from 'vue-router'
import InfoDialog from "./InfoDialog.vue";

const {  ecos, clearMapStyle,  processedData, print, printing,  loadDataByID } = useMapItems()
const { logGAevent } = useHelpers();
const router = useRouter()
const route = useRoute()

const props = defineProps({
    rawData: { type: Object },
    version: { type: Number },
})

const { rawData, version } = toRefs(props)

const infoDialogs = ref({
  dependencyIntensity: {
    pName: "Fishing Dependency and Intensity",
    model: false,
    text: "Fishing dependency is a measure of the percent of fishing effort for a given community within the Area of Interest. Fishing intensity is a sum of the number of fisher days spent within the AOI."
  },

})


const cas = ref(false)
const summary = ref(false)
const otherAct = ref(false)
const dataqual = ref(false)

const panelRefs = {
    summary,
    cas,
    otherAct,
    dataqual
}
const setExpansionPanel = (refName, value) =>{
  if (panelRefs[refName]) {
    panelRefs[refName].value = value;
  }
}

const goTo = (pane, layerID=null) =>{
    logGAevent("people_pane", pane, "")
    if (layerID){
        loadDataByID(layerID, version)
    }
    router.push({
        path: `/results${version.value}/people/${pane}`
    })
}

const setPanels = (path) =>{
    clearMapStyle();
    if (path.includes('people/summary')){
        setExpansionPanel('summary', true)
    }
    if (path.includes('people/cas')){
        setExpansionPanel('cas', true)
    }
    if (path.includes('people/other')){
        setExpansionPanel('otherAct', true)
    }
    if (path.includes('people/data')){
        setExpansionPanel('dataqual', true)
    }
}

watch(route, (nv, ov) =>{
    setPanels(nv.fullPath)
})

onMounted(() => {
    // if coming from a route (entered via URL).  expand the correct panel
    setPanels(route.path)
})

onUnmounted( () =>{

});

</script>
<style scoped>
.table-container{
    max-width: 400;
    /* overflow: hidden; */

}
.tableheader{
    text-wrap: wrap;
  
}
.rounded{
    border-radius: 3px;
}
.exp-panel{
    border-top: 1px solid #aeaeae;
    border-left: 1px solid #aeaeae;
    border-right:1px solid #aeaeae;
    background-color: #f7f7f7;
 }
</style>